export interface OpenOrderData {
  key: string;
  id?: string | number;
  quoteId: string;
  rep: string;
  poDate: string;
  custPo: string;
  customer: string;
  gm: string;
  gs: string;
  shipping?: string;
  pmt: string;
  poStatus: string;
  rental: string;
  comments: string;
  salesOrder?: string;
  vendorRma?: string;
  manu?: string;
  model?: string;
  sn?: string;
  qty?: string;
  vendor?: string;
  dateShipped?: string;
  trackingNo?: string;
  rma?: string;
  rmaComment?: string;
  rentalPeriod?: string;
  manu2?: string;
  model2?: string;
  sn2?: string;
  qty2?: string;
  vendor2?: string;
  dateShipped2?: string;
  trackingNo2?: string;
  rentalPeriod2?: string;
  manu3?: string;
  model3?: string;
  qty3?: string;
  vendor3?: string;
  manu4?: string;
  model4?: string;
  qty4?: string;
  vendor4?: string;
  manu5?: string;
  model5?: string;
  qty5?: string;
  vendor5?: string;
  invoiceDate?: string;
  ateInvoiceNo?: string;
  invoiceDueDate?: string;
  invoiceTotal?: string;
  paid?: string;
  orderComplete?: string;
  leadFrom?: string;
  actions?: string;
  vendorPaid?: string;
}

export const parseNumberOrNull = (value: string | undefined) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed.replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
};

// Like parseNumberOrNull but rounds to the nearest whole dollar on save.
export const parseRoundedOrNull = (value: string | undefined) => {
  const parsed = parseNumberOrNull(value);
  return parsed === null ? null : Math.round(parsed);
};

export const parseIntegerOrNull = (value: string | undefined) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  return Number.isInteger(parsed) ? parsed : null;
};

export const parseBooleanOrNull = (value: string | undefined) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();
  if (!normalized) return null;
  if (["true", "1", "yes", "y"].includes(normalized)) return true;
  if (["false", "0", "no", "n"].includes(normalized)) return false;
  return null;
};

export const buildOrderTrackingCreatePayload = (record: OpenOrderData) => ({
  quote_id: record.quoteId || null,
  rep: record.rep || null,
  date: record.poDate || null,
  po_number: record.custPo || null,
  customer: record.customer || null,
  gross_margin: parseNumberOrNull(record.gm),
  gross_sale: parseNumberOrNull(record.gs),
  shipping_cost: parseNumberOrNull(record.shipping),
  wire: record.pmt || null,
  po_status: record.poStatus || null,
  rental: parseBooleanOrNull(record.rental),
  comments: record.comments || null,
  sales_order: record.salesOrder || null,
  vendor_rma: record.vendorRma || null,
  manu: record.manu || null,
  model: record.model || null,
  serial_num1: record.sn || null,
  qty: parseIntegerOrNull(record.qty),
  vendor: record.vendor || null,
  date_shipped: record.dateShipped || null,
  tracking_no: record.trackingNo || null,
  rma: record.rma || null,
  rma_comment: record.rmaComment || null,
  rental_period: record.rentalPeriod || null,
  manu2: record.manu2 || null,
  model_2: record.model2 || null,
  serial_num2: record.sn2 || null,
  qty_2: parseIntegerOrNull(record.qty2),
  vendor2: record.vendor2 || null,
  date_shipped_2: record.dateShipped2 || null,
  rental_period2: record.rentalPeriod2 || null,
  manu3: record.manu3 || null,
  model_3: record.model3 || null,
  qty_3: parseIntegerOrNull(record.qty3),
  vendor3: record.vendor3 || null,
  manu4: record.manu4 || null,
  model_4: record.model4 || null,
  qty_4: parseIntegerOrNull(record.qty4),
  vendor4: record.vendor4 || null,
  manu5: record.manu5 || null,
  model_5: record.model5 || null,
  qty_5: parseIntegerOrNull(record.qty5),
  vendor5: record.vendor5 || null,
  invoice_date: record.invoiceDate || null,
  ate_invoice_no: record.ateInvoiceNo || null,
  invoice_due_date: record.invoiceDueDate || null,
  invoice_total: parseRoundedOrNull(record.invoiceTotal),
  paid: record.paid || null,
  order_complete: record.orderComplete || null,
  lead_from: record.leadFrom || null,
  actions: record.actions || null,
  when: record.vendorPaid || null,
});

export const createBlankOpenOrderRecord = (): OpenOrderData => ({
  key: `new-${Date.now()}`,
  quoteId: "",
  rep: "",
  poDate: "",
  custPo: "",
  customer: "",
  gm: "",
  gs: "",
  pmt: "",
  poStatus: "",
  rental: "",
  comments: "",
});
